/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MatchLocationEnum {
    ALL = 'all',
    HOME = 'home',
    AWAY = 'away',
}
